import { isEmpty, isNumber, omit, toNumber } from "lodash";
import { TAnalyticData } from "../pages/analytics";
import { TAnalyticsFilters } from "../shared/types/analyticsFilters.type";
import { hands } from "../enums/trackGroup.enums";
import { harness } from "../enums/harness.enum";

export function getPatloadForSavingView(analyticData: TAnalyticData, filters?: TAnalyticsFilters) {



    let data: any = {
        all_hand_turns: isEqualAnalyticData(analyticData.hands, filters?.hands || [], true),
        hand_turns: analyticData.hands,

        all_harnessed_mounteds: isEqualAnalyticData(analyticData.harnessed_mounteds, filters?.harnessed_mounteds || [], true),
        harnessed_mounteds: analyticData.harnessed_mounteds,

        all_horse_ages: isEmpty(analyticData.horse_ages),
        horse_ages: analyticData.horse_ages,



        all_horses: isEqualAnalyticData(analyticData.horses, filters?.horses || [], false),
        horses: filters?.horses.filter(f => analyticData.horses.includes(f.id)).map(e => e['@id']),



        all_riders: isEqualAnalyticData(analyticData.riders, filters?.riders || [], true),
        riders: filters?.riders.filter(f => analyticData.riders.includes(f.id)).map(e => e['@id']),

        all_track_conditions: isEqualAnalyticData(analyticData.track_conditions, filters?.track_conditions || [], true),
        track_conditions: filters?.track_conditions.filter(f => analyticData.track_conditions.includes(f.id)).map(e => e['@id']),

        all_track_names: isEqualAnalyticData(analyticData.track_names, filters?.track_names || [], true),
        track_names: filters?.track_names.filter(f => analyticData.track_names.includes(f.id)).map(e => e['@id']),

        all_track_surfaces: isEqualAnalyticData(analyticData.track_surfaces, filters?.track_surfaces || [], true),
        track_surfaces: filters?.track_surfaces.filter(f => analyticData.track_surfaces.includes(f.id)).map(e => e['@id']),

        all_training_types: isEqualAnalyticData(analyticData.training_types, filters?.training_types || [], true),
        training_types: filters?.training_types.filter(f => analyticData.training_types.includes(f.id)).map(e => e['@id']),

        all_trainers: isEqualAnalyticData(analyticData.trainers, filters?.trainers || [], true),
        trainers: filters?.trainers.filter(f => analyticData.trainers.includes(f?.id ?? null)).map(e => e['@id']),


        "include_null_hand": analyticData.hands.includes(null),
        "include_null_harnessed_mounted": analyticData.harnessed_mounteds.includes(null),
        "include_null_horse_age": analyticData.horse_ages.includes(null),
        "include_null_horse_shoeing": analyticData.horse_shoeings.includes(null),
        "include_null_rider": analyticData.riders.includes(null),
        "include_null_track_condition": analyticData.track_conditions.includes(null),
        "include_null_track_name": analyticData.track_names.includes(null),
        "include_null_track_surface": analyticData.track_surfaces.includes(null),
        "include_null_training_type": analyticData.training_types.includes(null),

        "include_horses_out_of_training": analyticData.include_horses_out_of_training,
        "only_reference_trainings": analyticData.only_reference_trainings,

        "insight_value_criterias": analyticData.insight_value_criterias.map(e => {

            let obj = {
                ...e,
                insight_parameter: filters?.insight_value_filters.find(f => f.insight_parameter.name === e.field)?.insight_parameter["@id"]
            }

            return omit(obj, 'field')

        })






    }

    return data

}

function isEqualAnalyticData(analytics: any[], filters: any[], acceptNull: boolean) {


    return analytics.length === filters.length + (acceptNull ? 1 : 0)

}